module.exports = __webpack_public_path__ + "img/kt3.bae0f89b.png";